function FirstPage() {

    return (
        <div className='card'>
            <div className='profile-picture'>
                <div loading="lazy" className='profile-banner'></div>
                <img loading="lazy" src={"/images/profile/icon.jpg"} width={200} alt="" />
            </div>
            <div className='personal-info'>
                <span>Gelff</span>
            </div>
            <label className='label'>﴾ Social Media ﴿</label>
            <div className='my-links'>
                <a title='Discord' href='http://discord.com/users/1096652093365952603' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/discord.png' width={30} alt="" /></button>
                </a>
                <a title='Steam' href='https://steamcommunity.com/id/biohazardzx/' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/steam.png' width={30} alt="" /></button>
                </a>
                <a title='Roblox' href='https://www.roblox.com/users/3354859054/profile' target='_blank' rel='noreferrer'>
                    <button className='my-links-button'><img src='/images/roblox.png' width={30} alt="" /></button>
                </a>
            </div>
            <label className='label'>﴾ My Projects ﴿</label>
            <div className='projects'>
                <div className='project'>
                    <img loading="lazy" src='/images/projects/mirai.png' width={110} alt="" />
                    <div>
                        <span>Roblox UGC Store</span>
                        <span style={{ fontSize: 12 }}>• Roblox • UGC</span>
                        <span style={{ fontSize: 12 }}>• Games • Clothes</span>
                        <a title='Roblox UGC Store' href='https://www.roblox.com/communities/35080877/Gelff' target='_blank' rel='noreferrer'>
                            <button className='projects-button'>Join</button>
                        </a>
                    </div>
                </div>
                <div className='project'>
                    <img loading="lazy" src='/images/projects/minimania.png' width={110} alt="" />
                    <div>
                        <span>MiniMania</span>
                        <span style={{ fontSize: 12 }}>• Game • Economy</span>
                        <span style={{ fontSize: 12 }}>• Social • Collection</span>
                        <a title='MiniMania' href='https://minimania.app/?ref=gelffminimania' target='_blank' rel='noreferrer'>
                            <button className='projects-button'>Join</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FirstPage